'use strict';

angular.module('app')
    .controller('LiveaboardDivingCtrl', function($scope, item, Destinations, Search, GTM) {

        var vm = this;

        vm.info = item;
        vm.search = Search;

        GTM.variables({
            country_name: vm.info.countryTitle,
            country_id: vm.info.countryId,
            area_name: vm.info.areaTitle || null,
            area_id: vm.info.areaId || null
        });

        Destinations.getHighlights().then(function(data) {
            vm.info.highlights = data.info;
        });

        Destinations.getShopByKind("liveaboard").then(function(data) {
            vm.shops = data.results;
            vm.totalLA = data.count;



            string = '';

            _.each(data.results, function(val) {
                string += val.id + ','
            });

            GTM.variables({operator_id: string.slice(0,-1) });
        });



    });